import { CloseIcon, IconButton, Tooltip, classNames } from '@movingimage-evp/mi-ui-component-library';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';

import { useMediaQuery } from '../../../common/media-query-provider';
import { Chat } from '../../../components/chat';
import { useChat } from '../../../components/chat/use-sendbird-chat';
import { ChatType } from '../../../generated/graphql-viewer';
import { ModeratedChat } from '../moderated-chat';

import styles from './viewer-chat.module.css';

type Props = {
  chatType?: ChatType;
  hasSecurityPolicy?: boolean;
  useProvidedUsername?: boolean;
  inIframe?: boolean;
  onNicknameSubmit: (nickname?: string) => void;
  onClose: () => void;
};

export function ViewerChat({
  chatType,
  hasSecurityPolicy,
  useProvidedUsername,
  inIframe,
  onNicknameSubmit,
  onClose,
}: Props) {
  const { t } = useTranslation();
  const chat = useChat();
  const { isMobile } = useMediaQuery();

  useEffect(() => {
    if (isMobile) window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
  }, [isMobile]);

  if (!chatType) return null;

  return (
    <div data-testid="viewer-chat" className={classNames(styles.wrapper, inIframe && styles.inIframe)}>
      <header className={styles.header}>
        <div data-testid="viewer-chat-title">{t(`viewer.views.stream.chat.title.${chatType}`)}</div>

        <Tooltip label={t(`viewer.views.stream.chat.buttons.close.tooltip.${chatType}`)}>
          <IconButton
            data-testid="close-button"
            aria-label={t(`viewer.views.stream.chat.buttons.close.tooltip.${chatType}`)}
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </Tooltip>
      </header>

      {chatType === ChatType.UNMODERATED && (
        <Chat
          chat={chat}
          hasSecurityPolicy={hasSecurityPolicy}
          anonymous={!useProvidedUsername}
          onNicknameSubmit={onNicknameSubmit}
        />
      )}

      {chatType === ChatType.MODERATED && (
        <ModeratedChat
          chat={chat}
          hasSecurityPolicy={hasSecurityPolicy}
          anonymous={!useProvidedUsername}
          onNicknameSubmit={onNicknameSubmit}
        />
      )}
    </div>
  );
}
